import type { Variants } from "motion/react";

export const lenderMonthlyInputVariants: Variants = {
  initial: {
    opacity: 0,
    y: -24,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", duration: 0.2, bounce: 0.15 },
  },
  exit: {
    opacity: 0,
    y: -24,
    transition: { type: "spring", duration: 0.2, bounce: 0.15 },
  },
};
